import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlServer } from '../global_constants';

/** MF-1879 : codes renvoyés par l'API /v1/google (MD5 de GCAL000..GCAL013, cf. IResponsesCodes côté backend). */
export const GOOGLE_CODES = {
  CONNECT_URL_SUCCESS: '3c8357727091cdc61f83858ad53c8eb1',
  TOKEN_ERROR: '6ffe272409c5603a9d76e6999e6eb687',
  NOT_CONFIGURED: '268b0607649068341c9163cf0845dd06',
  STATUS_SUCCESS: '2a02b5abe834d8dcb0f8affe3ecadc4c',
  DISCONNECTED: '378f04adee13a9501f6e488e6c2025ac',
  NOT_CONNECTED: '31fe4078f1c4cd8d6e2b0b07e2acd5a6',
  CALENDARS_SUCCESS: 'f1958636317f2d4f1acffac338cfaf42',
  CALENDAR_SELECTED: 'e25cf8385e6b9474eb9781c51629e465',
  CALENDAR_INVALID: 'ba6fe6165247101e793577bbfc30ce9d',
  SYNC_SUCCESS: 'ece52d07aea5ddabde13ea7de16c37ab',
  SYNC_FAILED: '981d60d6d1dca20a37ac459ae96d80ae',
  SYNC_VISIT_NOT_FOUND: 'cb706a9716748844bd5ccf2dac8bbfce',
  AUTH_REVOKED: 'aa325f9619d0f1f557c314e663bfdca6',
  ERROR: 'f8195f9ba058aec558ee7f55c09e2e1c',
};

export interface GoogleStatus {
  code: string;
  connected?: boolean;
  status?: 'CONNECTED' | 'REVOKED';
  email?: string;
  calendarId?: string;
  calendarName?: string;
  connectedAt?: string;
  message?: string;
}

export interface GoogleCalendar {
  id: string;
  name: string;
  primary: boolean;
  selected: boolean;
}

export interface GoogleCalendarsResponse {
  code: string;
  calendars?: GoogleCalendar[];
  message?: string;
}

export interface GoogleSyncResponse {
  code: string;
  visit?: string;
  syncStatus?: 'OK' | 'ERROR' | 'PENDING';
  result?: string;
  message?: string;
  lastSyncAt?: string;
  visitsInError?: string[];
}

/**
 * MF-1879 : appels vers l'API Google Agenda du backend.
 * Le front ne manipule jamais de jeton Google : il reçoit seulement l'URL de consentement.
 */
@Injectable({
  providedIn: 'root'
})
export class GoogleCalendarService {

  private baseUrl: string = urlServer.concat('/v1/google');

  constructor(private http: HttpClient) { }

  /** Jeton lu à chaque appel (il peut changer après une reconnexion). */
  private headers(): HttpHeaders {
    const token = localStorage.getItem('token') != null && localStorage.getItem('token') != undefined
      ? localStorage.getItem('token') : sessionStorage.getItem('token');
    return new HttpHeaders().set('authorization', 'Bearer ' + token);
  }

  getStatus(): Observable<GoogleStatus> {
    return this.http.get<GoogleStatus>(this.baseUrl + '/status', { headers: this.headers() });
  }

  getConnectUrl(): Observable<{ code: string; url?: string }> {
    return this.http.get<{ code: string; url?: string }>(this.baseUrl + '/connect', { headers: this.headers() });
  }

  disconnect(): Observable<GoogleStatus> {
    return this.http.delete<GoogleStatus>(this.baseUrl + '/disconnect', { headers: this.headers() });
  }

  getSyncErrors(): Observable<GoogleSyncResponse> {
    return this.http.get<GoogleSyncResponse>(this.baseUrl + '/sync/errors', { headers: this.headers() });
  }

  getVisitSyncStatus(uuidVisit: string): Observable<GoogleSyncResponse> {
    return this.http.get<GoogleSyncResponse>(this.baseUrl + '/sync/' + uuidVisit, { headers: this.headers() });
  }

  retryVisitSync(uuidVisit: string): Observable<GoogleSyncResponse> {
    return this.http.post<GoogleSyncResponse>(this.baseUrl + '/sync/' + uuidVisit, {}, { headers: this.headers() });
  }
}
